document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        updatePriceMXN();
      }
    });
  });

  const priceWrapper = document.querySelector('[data-price]');
  if (priceWrapper) {
    observer.observe(priceWrapper.parentElement, {
      childList: true,
      subtree: true
    });
  }

  function updatePriceMXN() {
    const priceEl = document.querySelector('[data-price]');
    if (priceEl && !priceEl.textContent.includes('MXN')) {
      priceEl.textContent = priceEl.textContent.trim() + ' MXN';
    }

    const compareEl = document.querySelector('[data-compare-price]');
    if (compareEl && !compareEl.textContent.includes('MXN')) {
      compareEl.textContent = compareEl.textContent.trim() + ' MXN';
    }
  }

  // Ejecutar una vez al cargar
  updatePriceMXN();
});
